import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './Nav.css';

const Nav = () => (
  <div className="app-shell">
    <nav className="app-nav">
      <NavLink to="/" end className={({ isActive }) => `app-nav-tab ${isActive ? 'active' : ''}`}>
        Musique
      </NavLink>
      <NavLink to="/podcasts" className={({ isActive }) => `app-nav-tab ${isActive ? 'active' : ''}`}>
        Podcast
      </NavLink>
    </nav>
    <Outlet />
  </div>
);

export default Nav;
